/* eslint-disable react/no-unescaped-entities */
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';
import Seo from '../Seo';
import { CONTACT_EMAIL, DMCA_EMAIL, PAGE_SEO, SITE_NAME, SITE_URL } from '../../utils/seo';
import '../PrivacyPolicy/index.css';

export default function DmcaPolicy() {
  return (
    <Row style={{ display: 'flex', justifyContent: 'center', margin: '20px' }}>
      <Seo
        title={PAGE_SEO.DMCA.title}
        description={PAGE_SEO.DMCA.description}
        canonical={`${SITE_URL}/dmca`}
      />
      <Col span={18} md={18} xs={24}>
        <h1 className="card-category text-gray title-name">DMCA Copyright Policy</h1>
        <p className="date-display">Last updated: August 14, 2026</p>

        <p className="des-para">
          {SITE_NAME} respects the intellectual property rights of others and complies with the Digital
          Millennium Copyright Act of 1998 (17 U.S.C. § 512). This page explains how copyright owners
          can request removal of allegedly infringing material and how we handle those notices.
        </p>

        <h2>What Koostream hosts</h2>
        <p className="des-para">
          Koostream is a sports information website. We publish original editorial commentary, fixture
          lists, schedules, and standings. We do not host, store, or transmit copyrighted television
          broadcasts, pay-per-view events, or other audiovisual sports programming. Any third-party
          links that appear on the site are provided by users or external sources and are not owned or
          controlled by Koostream. Official live coverage of professional sports belongs exclusively to
          the relevant leagues, teams, and licensed broadcasters.
        </p>
        <p className="des-para">
          Team names, league names, logos, and trademarks remain the property of their respective
          owners and are used only for identification and news reporting.
        </p>

        <h2>Designated DMCA agent</h2>
        <p className="des-para">To file a copyright takedown notice, contact:</p>
        <ul>
          <li>
            <strong>Service provider:</strong> Koostream
          </li>
          <li>
            <strong>Website:</strong> {SITE_URL}
          </li>
          <li>
            <strong>Email:</strong> {DMCA_EMAIL}
          </li>
          <li>
            <strong>Alternate contact:</strong> {CONTACT_EMAIL} or our{' '}
            <Link to="/contact-us">contact form</Link> (include “DMCA” in the subject or first line)
          </li>
        </ul>

        <h2>How to submit a takedown notice</h2>
        <p className="des-para">
          A valid notice under 17 U.S.C. § 512(c)(3) must include all of the following:
        </p>
        <ul>
          <li>
            A physical or electronic signature of the copyright owner or a person authorized to act on
            the owner’s behalf.
          </li>
          <li>
            Identification of the copyrighted work claimed to have been infringed. If multiple works
            are covered by a single notice, a representative list is sufficient.
          </li>
          <li>
            Identification of the material that is claimed to be infringing, and information reasonably
            sufficient to permit us to locate it (the exact URL on koostream.live).
          </li>
          <li>
            Your name, mailing address, telephone number, and email address.
          </li>
          <li>
            A statement that you have a good-faith belief that use of the material in the manner
            complained of is not authorized by the copyright owner, its agent, or the law.
          </li>
          <li>
            A statement that the information in the notice is accurate, and under penalty of perjury,
            that you are authorized to act on behalf of the owner of an exclusive right that is
            allegedly infringed.
          </li>
        </ul>
        <p className="des-para">
          Incomplete notices may delay processing. We may share the notice with the user who submitted
          the material, if applicable.
        </p>

        <h2>Our response</h2>
        <p className="des-para">
          Upon receipt of a complete and valid notice, we will promptly remove or disable access to
          the identified material and take reasonable steps to notify the poster, if known. We
          maintain records of notices and may terminate accounts of repeat infringers when we have
          sufficient identifying information to do so.
        </p>

        <h2>Counter-notification</h2>
        <p className="des-para">
          If you believe material was removed by mistake or misidentification, you may send a
          counter-notification to {DMCA_EMAIL} that includes:
        </p>
        <ul>
          <li>Your physical or electronic signature.</li>
          <li>Identification of the material that was removed and the location where it appeared before removal.</li>
          <li>
            A statement under penalty of perjury that you have a good-faith belief the material was
            removed or disabled as a result of mistake or misidentification.
          </li>
          <li>Your name, address, telephone number, and email address.</li>
          <li>
            A statement that you consent to the jurisdiction of the Federal District Court for the
            judicial district in which your address is located (or, if outside the United States, for
            any judicial district in which Koostream may be found), and that you will accept service of
            process from the person who provided the original notice or that person’s agent.
          </li>
        </ul>
        <p className="des-para">
          After a valid counter-notification, we may restore the material unless the original
          complainant files a court action seeking to restrain the alleged infringement.
        </p>

        <h2>Repeat infringer policy</h2>
        <p className="des-para">
          Koostream has a policy of terminating, in appropriate circumstances, users who are repeat
          infringers. We also reserve the right to remove content and restrict access at our
          discretion, including where we receive a credible report of infringement even if a notice is
          incomplete.
        </p>

        <h2>Misrepresentation</h2>
        <p className="des-para">
          Under 17 U.S.C. § 512(f), any person who knowingly materially misrepresents that material is
          infringing, or that material was removed by mistake, may be liable for damages, including
          costs and attorneys’ fees.
        </p>

        <h2>Trademarks and other rights</h2>
        <p className="des-para">
          League, club, and athlete names and logos are trademarks of their respective owners. Use on
          this site is nominative and for news reporting only. If you believe a trademark is used in a
          way that is not fair or nominative, contact {DMCA_EMAIL} with the same locating information
          described above.
        </p>

        <h2>Related policies</h2>
        <ul>
          <li>
            <Link to="/terms">Terms of Service</Link>
          </li>
          <li>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </li>
          <li>
            <Link to="/contact-us">Contact Us</Link>
          </li>
        </ul>
      </Col>
    </Row>
  );
}
